"use strict";
/**
 * @module botframework-streaming
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Typess of payloads supported in the streaming library.
 */
var PayloadTypes;
(function (PayloadTypes) {
    PayloadTypes["request"] = "A";
    PayloadTypes["response"] = "B";
    PayloadTypes["stream"] = "S";
    PayloadTypes["cancelAll"] = "X";
    PayloadTypes["cancelStream"] = "C";
})(PayloadTypes = exports.PayloadTypes || (exports.PayloadTypes = {}));
//# sourceMappingURL=payloadTypes.js.map